import React, { useEffect, useState } from 'react';

import Icon from '../../../components/icon/Icon';
import InteractiveElement from '../../../components/interactive-element/InteractiveElement';
import { usePrevious } from '../../../core/hooks/usePrevious';
import { isMobileScreenSize } from '../../../core/utils/isMobileScreenSize';
import { history } from '../../../core/state/history';

import './CollapsiblePanel.scss';

interface Props {
  title: string;
  expanded?: boolean;
  onExpandChange?: (isCollapsed: boolean) => void;
  link?: string;
}

const CollapsiblePanel: React.FC<Props> = ({ title, expanded = false, children, onExpandChange, link }) => {
  const [isExpanded, setExpanded] = useState(expanded);
  const prevExpanded = usePrevious(expanded);
  const isMobileScreen = isMobileScreenSize();

  useEffect(() => {
    if (prevExpanded !== expanded) {
      setExpanded(expanded);
    }
  }, [expanded, prevExpanded, isExpanded]);

  const handlePanelContent = () => {
    if (link) {
      history.push(link);
      return;
    }
    if (onExpandChange) {
      onExpandChange(!isExpanded);
    }
    setExpanded(!isExpanded);
  };

  return (
    <div className={`collapsible-panel ${isMobileScreen ? 'collapsible-panel--mobile' : ''} ${isExpanded ? 'collapsible-panel--active' : ''}`}>
      <InteractiveElement className="collapsible-panel__heading" onClick={isMobileScreen ? handlePanelContent : () => {}}>
        <Icon
          className={`collapsible-panel__icon ${link && 'collapsible-panel__icon--right'} ${isMobileScreen && 'mr-0'}`}
          size="extra-small"
          icon="arrow"
          isButton
          withCard
          svg
          onClick={handlePanelContent}
        />
        <h3 className="collapsible-panel__title">{title}</h3>
      </InteractiveElement>
      {isExpanded && <div className="collapsible-panel__content">{children}</div>}
    </div>
  );
};

export default CollapsiblePanel;
